export function nameToSlug(name: string): string {
    return name.toLowerCase()
        .replace(/š/g, 's')
        .replace(/đ/g, 'dj')
        .replace(/č|ć/g, 'c')
        .replace(/ž/g, 'z')
        .trim()
        .replace(/[^a-z0-9]+/g, '-') // Replace non-alphanumeric characters with hyphens
        .replace(/^-+|-+$/g, ''); // Remove leading and trailing hyphens
}